import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import WithAuth from "./ProtectedRoute.jsx";
import WithoutAuth from "./PublicRoute.jsx";
import NotFound from "./components/NotFound/index.jsx";
import MainLayout from "./components/Layout";
import Report from "./pages/Reports";
import Setting from "./pages/Setting";
import Profile from "./pages/Profile";
import Scenario from "./pages/Scenario";
import CompanyDetails from "./pages/CompanyDetails/index.jsx";
import CreateScenario from "./components/CreateScenario";
import RiskOpportunity from "./pages/RIsksOpportunity/index.jsx";
import ForgetPassword from "./pages/ForgetPassword/index.jsx";
import MitigationPlan from "./pages/MitigationPlan/index.jsx";
import ScenarioDetailsPage from "./pages/ScenarioDetailsPage/index.jsx";
import RealTimeTrends from "./pages/RealTimeTrends/index.jsx";
import Collaboration from "./pages/Collaboration/index.jsx";
import RealTimeTrendDetails from "./pages/RealTimeTrendDetails/index.jsx";
import SectorDetailPage from "./pages/SectorsDetailPage/index.jsx";
import IndustryDetailPage from "./pages/IndustryDetailPage";
import DetailServices from "./pages/LandingPage/detailServices.jsx";
import Integrations from "./pages/Integrations/index.jsx";
import AppDashboard from "./pages/AppDashbaord/index.jsx";
import StripeDashboard from "./pages/StripeDashboard/index.jsx";
import ErpIntegrations from "./pages/ErpIntegrations/index.jsx";
import AsanaDashboard from "./pages/AsanaDashboard/index.jsx";
import QuickBooksDashboard from "./pages/QuickbooksDashboard/index.jsx";
import FreshBookDashboard from "./pages/FreshbookDashboard/index.jsx";
import NewLogin from "./pages/Login/NewLogin.jsx";
import NewSignUp from "./pages/Signup/newSignUp.jsx";
import CommandSystem from "./pages/CommandSystem/index.jsx";
import BusinessHealth from "./pages/BusinessHealth/index.jsx";
import RadarOverview from "./pages/RadarOverview/index.jsx";
import MarketTrends from "./pages/MarketTrends/index.jsx";
import BusinessTrends from "./pages/BusinessTrends/index.jsx";
import Tools from "./pages/Tools/index.jsx";
import NewPricing from "./pages/LandingPage/newPricing.jsx";
import AboutUsPage from "./pages/LandingPage/aboutUs.jsx";
import NewLandingPage from "./pages/NewLandingPage/index.jsx";
import FAQ from "./pages/NewLandingPage/Faq.jsx";
import DecisionComparison from "./pages/DecisionComparison/index.jsx";
import MarketPlaceLandingPage from "./pages/MarketPlaceLandingPage/index.jsx";
import BusinessToolMarketPlace from "./pages/BusinessToolMarketPlace/index.jsx";
import UploadTool from "./pages/BusinessToolMarketPlace/UploadTool.jsx";
import MarketplaceCmp from "./pages/BusinessToolMarketPlace/MarketPlace.jsx";
import Cart from "./pages/BusinessToolMarketPlace/Cart.jsx";
import CreatorProfile from "./pages/BusinessToolMarketPlace/CreatorProfile.jsx";
import MyTools from "./pages/BusinessToolMarketPlace/MyTools.jsx";

import ToolDetail from "./pages/BusinessToolMarketPlace/ToolDetail.jsx";
import RadarCreatorHub from "./pages/BusinessToolMarketPlace/RadarCreatorHub.jsx"
import StrategicGoalSetup from "./pages/StratigicGoal/index.jsx";
import DemoSection from "./components/DemoSection/index.jsx";
import WelcomeModal from "./components/WellcomeModal/WellcomeModal.js";
import { useEffect, useState } from "react";
import Tutorials from "./components/Tutorials/Tutorials.jsx";
function App({ applyTheme, theme }) {
  const [startTour, setStartTour] = useState(false);
  const [showTutorials, setShowTutorials] = useState('');
  const handleSkipTutorial = () => {
    localStorage.setItem('showTutorials', 'shown');
    setShowTutorials('shown');
  }
  useEffect(() => {
    const showTutorials = localStorage.getItem('showTutorials');
    if(!showTutorials) setShowTutorials('');
    else setShowTutorials('shown')
  }, [startTour])
  return (
    <BrowserRouter>
      {startTour && <Tutorials startTour={startTour} handleStartTour={() => setStartTour(false)} />}
      <Routes>
        <Route
          path="/home"
          element={
            <WithAuth>
              <>
                {!showTutorials && <div
                  style={{
                    minHeight: "100vh",
                    background: "#f5f5f5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                  }}
                >
                  <WelcomeModal startTour={() => setStartTour(true)} skipTutorial={handleSkipTutorial} />
                </div>}
                <MainLayout applyTheme={applyTheme} theme={theme} />
              </>
            </WithAuth>
          }
        >
          <Route
            path="stratigic-goal"
            element={<StrategicGoalSetup />}
          />
          <Route
            path="real-time-trends-detail/:id"
            element={<RealTimeTrendDetails />}
            breadcrumb="Real Time Trends Details"
          />

          <Route
            path="objective-analysis"
            element={<Scenario />}
            breadcrumb="Objective Analysis"
          />
          <Route
            path="create-scenario"
            element={<CreateScenario />}
            breadcrumb="Create Scenario"
          />
          <Route
            path="collaboration"
            element={<Collaboration />}
            breadcrumb="Collaboration"
          />
          <Route
            path="integrations"
            element={<Integrations />}
            breadcrumb="Integrations"
          />
          <Route
            path="erp-integrations"
            element={<ErpIntegrations />}
            breadcrumb="ERP Integrations"
          />
          <Route path="reports" element={<Report />} breadcrumb="Reports" />
          <Route path="profile" element={<Profile />} breadcrumb="Profile" />
          <Route path="support" element={<Setting />} breadcrumb="Support" />
          <Route
            path="risk-opportunity/:id/:category"
            element={<RiskOpportunity />}
            breadcrumb="Risk & Opportunity"
          />
          <Route
            path="mitigation-plan/:id"
            element={<MitigationPlan />}
            breadcrumb="Mitigation Plan"
          />
          <Route
            path="scenario-details/:id"
            element={<ScenarioDetailsPage />}
            breadcrumb="Scenario Details"
          />

          <Route
            path="real-time-trends"
            element={<RealTimeTrends />}
            breadcrumb="Real TIme Trends"
          />
          <Route
            path="sectors-details/:id"
            element={<SectorDetailPage />}
            breadcrumb="Sector Details"
          />
          <Route
            path="sectors-details/:id/industry-details/:industryId"
            element={<IndustryDetailPage />}
            breadcrumb="Industry Details"
          />
          <Route
            path="integrated-app-dashboard/:id"
            element={<AppDashboard />}
            breadcrumb="Integrated App Dashboard"
          />
          <Route
            path="stripe-dashboard"
            element={<StripeDashboard />}
            breadcrumb="Integrated App Dashboard"
          />
          <Route
            path="asana-dashboard"
            element={<AsanaDashboard />}
            breadcrumb="Asana App Dashboard"
          />
          <Route
            path="quickbooks-dashboard"
            element={<QuickBooksDashboard />}
            breadcrumb="QuickBooks App Dashboard"
          />
          <Route
            path="freshbooks-dashboard"
            element={<FreshBookDashboard />}
            breadcrumb="FreshBooks App Dashboard"
          />
          <Route
            index
            element={<CommandSystem isOnTour={startTour ? true : undefined} />}
            breadcrumb="Command System"
          />
          <Route
            path="business-health"
            element={<BusinessHealth />}
            breadcrumb="Business Health"
          />
          <Route
            path="radar-overview"
            element={<RadarOverview />}
            breadcrumb="Radar Overview"
          />
          <Route
            path="market-trends"
            element={<MarketTrends />}
            breadcrumb="Market Trends"
          />
          <Route
            path="business-trends"
            element={<BusinessTrends />}
            breadcrumb="Business Trends"
          />
          <Route path="tools" element={<Tools />} breadcrumb="Tools" />
          <Route path="decision-comparison" element={<DecisionComparison />} breadcrumb="Decision Comparison" />
        </Route>

        <Route path="/" element={<NewLandingPage />} />
        <Route path="/services" element={<DetailServices />} />
        <Route path="/pricing" element={<NewPricing />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/marketplace" element={<MarketPlaceLandingPage />} />
        <Route path="/demos" element={<DemoSection />} />

        {/* Settings */}

        <Route path="/settings" element={
          <WithAuth>
            <Setting />
          </WithAuth>
          } />


        {/* Business Tool Marketplace */}

        <Route
          path="/business-tool-marketplace"
          element={
            <WithAuth>
              <BusinessToolMarketPlace />
            </WithAuth>
          }
        >
          <Route
            index
            element={
              <MarketplaceCmp />
            }
          />
          <Route path="upload" element={<UploadTool />} />
          <Route path="tool/:id" element={<ToolDetail />} />
          <Route path="cart" element={<Cart />} />
          <Route path="creator/:id" element={<CreatorProfile />} />
          <Route path="tools/dashboard" element={<MyTools />} />
          <Route path="creator-hub" element={<RadarCreatorHub />} />
        </Route>

        <Route
          path="/login"
          element={
            <WithoutAuth>
              <NewLogin />
            </WithoutAuth>
          }
        />
        <Route
          path="/company-details"
          element={
            <WithAuth>
              <CompanyDetails />
            </WithAuth>
          }
        />
        <Route
          path="/register"
          element={
            <WithoutAuth>
              <NewSignUp />
            </WithoutAuth>
          }
        />
        <Route
          path="/forget-password"
          element={
            <WithoutAuth>
              <ForgetPassword />
            </WithoutAuth>
          }
        />
        <Route
          path="*"
          element={
            <WithoutAuth>
              <NotFound />
            </WithoutAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
